import {mergeAttributes,} from '@tiptap/core'
import {Node} from '@tiptap/react'






 

































export const FileUploadBase = Node.create({
  name: 'fileUpload',

  isolating: true,

  defining: true,

  group: 'block',

  draggable: true,

  selectable: true,

  inline: false,
  addAttributes() {
    return {
      targetType: {
        default: 'file',
        parseHTML: (element) => element.getAttribute('target-type'),
        renderHTML: (attributes) => ({
          'target-type': attributes.targetType
        })
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: `div[data-type="${this.name}"]`
      }
    ]
  },

  renderHTML({HTMLAttributes}) {
    return ['div', mergeAttributes(HTMLAttributes, {'data-type': this.name})]
  }
})
